export default __webpack_public_path__ + "static/media/home_anime.f372ef86.gif";